var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"qrcode-reader"}},[_c('video',{attrs:{"autoplay":"","playsinline":""}}),_vm._v(" "),_c('canvas'),_vm._v(" "),_c('div',[_c('p',{staticClass:"is-cs-2 has-text-weight-bold has-text-centered"},[_vm._v("QRコードを枠内に入れてください")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6677ebaa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view-model/qrcode-reader.vue
// module id = null
// module chunks = 